import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGamOverviewAmp = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M11.4482 20.3677V14.0616H7.56638C7.36341 14.0616 7.20484 13.9673 7.09066 13.7786C6.97649 13.59 6.97015 13.3879 7.07164 13.1723L11.7526 3.34937C11.8795 3.05294 12.0888 2.94514 12.3806 3.02599C12.6723 3.10683 12.8182 3.30895 12.8182 3.63234V10.0192H16.4336C16.6366 10.0192 16.7952 10.1136 16.9093 10.3022C17.0235 10.4909 17.0299 10.693 16.9284 10.9086L12.5138 20.6506C12.3869 20.9471 12.1776 21.0549 11.8858 20.974C11.5941 20.8932 11.4482 20.691 11.4482 20.3677Z" })
});
export default SvgGamOverviewAmp;
